import { HttpErrorResponse } from '@angular/common/http';

export const CONNECTION_ERROR_MESSAGE =
  'We are having trouble connecting to the service right now. Please try again in a few moments.';

export function getAuthErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    if (isConnectionError(error)) {
      return CONNECTION_ERROR_MESSAGE;
    }
    return extractMessage(error.error, error.message, fallback);
  }

  if (error && typeof error === 'object') {
    const objectError = error as { error?: unknown; message?: unknown };
    return extractMessage(objectError.error ?? error, objectError.message, fallback);
  }

  return fallback;
}

function isConnectionError(error: HttpErrorResponse): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }

  // status 0: the browser never got an HTTP response (dropped connection, DNS
  // failure, request timeout, CORS/network rejection).
  // 502/503/504: the server or an upstream gateway is unavailable or not
  // responding. In every case there is no meaningful message body to show.
  return error.status === 0 || [502, 503, 504].includes(error.status);
}

function extractMessage(payload: unknown, fallbackMessage: unknown, fallback: string): string {
  if (typeof payload === 'string' && payload.trim()) {
    return payload.trim();
  }

  if (payload && typeof payload === 'object') {
    const candidate = payload as { message?: unknown; error?: unknown; detail?: unknown; title?: unknown };

    for (const value of [candidate.message, candidate.error, candidate.detail, candidate.title]) {
      if (typeof value === 'string' && value.trim()) {
        return value.trim();
      }
    }
  }

  if (typeof fallbackMessage === 'string' && fallbackMessage.trim()) {
    return fallbackMessage.trim();
  }

  return fallback;
}
